// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__XRWkD","rootCenter":"LoadMoreObserver_rootCenter__3CS85","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1ebcJ"};